import { RegisteredComponent } from "@builder.io/sdk-react";

export const cscInternalSearchContextBlockConfig: Omit<
  RegisteredComponent,
  "component"
> = {
  name: "CscInternalSearchContextBlock",
  friendlyName: "CSC Internal Search Context",
  hideFromInsertMenu: process.env.SITE !== "support",
  noWrap: true,
  canHaveChildren: true,
  shouldReceiveBuilderProps: {
    builderContext: true,
  },
  inputs: [
    {
      name: "sitesFilterText",
      type: "string",
      defaultValue: "Content Type",
    },
    {
      name: "categoriesFilterText",
      type: "string",
      defaultValue: "Product Name",
    },
  ],
};
